module.exports = __webpack_public_path__ + "static/wff-sec5-03-a2baafa4eb535e8fdeb9cd7145edf750.jpg";